// Disable noisy console methods in production builds
if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
	const noop = () => {};
	// Keep warnings and errors visible; silence info/debug/log/trace
	/* eslint-disable no-console */
	console.log = noop;
	console.info = noop;
	console.debug = noop;
	console.trace = noop;
	/* eslint-enable no-console */
}


